import { create } from 'zustand';
import { UIState, ModalName, LoadingName } from '../types/store';

interface UIStore extends UIState {
  // Modal actions
  openModal: (modalName: ModalName) => void;
  closeModal: (modalName: ModalName) => void;
  closeAllModals: () => void;
  toggleModal: (modalName: ModalName) => void;
  
  // Loading actions
  setLoading: (loadingName: LoadingName, isLoading: boolean) => void;
  setAuthLoading: (isLoading: boolean) => void;
  setApiLoading: (isLoading: boolean) => void;
  setUploadLoading: (isLoading: boolean) => void;
}

export const useUIStore = create<UIStore>((set, get) => ({
  // Initial state
  modals: {
    signIn: false,
    createKandi: false,
    selectLocation: false,
    setProfilePhoto: false,
    firstTimeSignin: false,
    createKandiCheckIn: false,
    addTag: false,
  },
  loading: {
    auth: false,
    api: false,
    upload: false,
  },

  // Modal actions
  openModal: (modalName: ModalName) => {
    set((state) => ({
      modals: {
        ...state.modals,
        [modalName]: true,
      },
    }));
  },

  closeModal: (modalName: ModalName) => {
    set((state) => ({
      modals: {
        ...state.modals,
        [modalName]: false,
      },
    }));
  },

  closeAllModals: () => {
    set((state) => ({
      modals: Object.keys(state.modals).reduce((acc, key) => {
        acc[key as ModalName] = false;
        return acc;
      }, {} as Record<ModalName, boolean>),
    }));
  },

  toggleModal: (modalName: ModalName) => {
    set((state) => ({
      modals: {
        ...state.modals,
        [modalName]: !state.modals[modalName],
      },
    }));
  },

  // Loading actions
  setLoading: (loadingName: LoadingName, isLoading: boolean) => {
    set((state) => ({
      loading: {
        ...state.loading,
        [loadingName]: isLoading,
      },
    }));
  },

  setAuthLoading: (isLoading: boolean) => {
    get().setLoading('auth', isLoading);
  },

  setApiLoading: (isLoading: boolean) => {
    get().setLoading('api', isLoading);
  },

  setUploadLoading: (isLoading: boolean) => {
    get().setLoading('upload', isLoading);
  },
}));
